export default "../fonts/akzidgrtskprobolcnd-webfont.5313ff16abce3c64dbd0a01169490019.woff";